// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"22906c65","354":"e60f1f63","838":"bbfa1ef6"}[chunkId] + ".js";
};